import { useState, useCallback, useRef, createRef } from "react";
import { Link } from "react-router-dom";
import "./css/novedades.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import fondoVideo from "../../images/home/videos/fondoVideo.webp";
import 'react-lazy-load-image-component/src/effects/opacity.css';
//Miniaturas
import VisionLarge from "../../images/home/miniaturas/hyundai-nuestra-vision.webp";
import VisionMedium from "../../images/home/miniaturas/hyundai-nuestra-vision-medium.webp";
import VisionSmall from "../../images/home/miniaturas/hyundai-nuestra-vision-small.webp";
import SueniosLarge from "../../images/home/miniaturas/hyundai-construyendo-suenios.webp";
import SueniosMedium from "../../images/home/miniaturas/hyundai-construyendo-suenios-medium.webp";
import SueniosSmall from "../../images/home/miniaturas/hyundai-construyendo-suenios-small.webp";
import InnovacionLarge from "../../images/home/miniaturas/hyundai-innovacion.webp";
import InnovacionMedium from "../../images/home/miniaturas/hyundai-innovacion-medium.webp";
import InnovacionSmall from "../../images/home/miniaturas/hyundai-innovacion-small.webp";
import HyundaiCareDesktop from "../../images/home/ofertas/my-hyundai-care.webp";
import HyundaiCareMovil from "../../images/home/ofertas/my-hyundai-care-movil.webp";
import BannerCreta from "../../images/home/ofertas/creta.webp";
import BannerMovilCreta from "../../images/home/ofertas/creta-movil.webp";
import BannerAccent from "../../images/home/ofertas/accent.webp";
import BannerMovilAccent from "../../images/home/ofertas/accent-movil.webp";
import BannerTucson from "../../images/home/ofertas/tucson-desktop.webp";
import BannerMovilTucson from "../../images/home/ofertas/tucson-mobile.webp";
import BannerSantaFe from "../../images/home/ofertas/santafe-desktop.webp";
import BannerMovilSantaFe from "../../images/home/ofertas/santafe-mobile.webp";
import BannerPrepagados from "../../images/home/ofertas/banner-p.webp";
import BannerPrepagadosMovil from "../../images/home/ofertas/banner-p-movil.webp";
import BannerMundial2026 from "../../images/home/ofertas/banner-mundial-2026.jpg";
import BannerMovilMundial2026 from "../../images/home/ofertas/banner-mundial-2026-movil.jpg";
import Card from "react-bootstrap/Card";
import "../vehiculos/css/catalogo.css";
import { Button, Carousel } from "react-bootstrap";
import CarouselNoticias from "../noticias/CarouselNoticias";
import SantaFe from "../../images/lanzamientos/santafe.webp"
import Palisade from "../../images/lanzamientos/palisade.webp";
import Creta from "../../images/lanzamientos/creta.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

function Novedades() {
    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 500,
    };
    const settingsMobile = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    function YouTubePlayer({ dataSrc, title, thumbnail }) {
        const [showVideo, setShowVideo] = useState(false);
        const handlePlay = useCallback(() => {
            setShowVideo(true);
        }, []);
        return (
            <div className="youtube-player">
                {!showVideo && (
                    <>
                        <LazyLoadImage
                            src={thumbnail}
                            alt={title}
                            onClick={handlePlay}
                            effect="blur"
                            fluid="true"
                            className="w-100 p-0 imagen-home"
                        />
                        <div className="play-button" onClick={handlePlay}></div>
                    </>
                )}
                {showVideo && (
                    <iframe
                        className="video-youtube"
                        src={dataSrc}
                        title={title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        sandbox="allow-scripts allow-same-origin allow-presentation"
                    ></iframe>
                )}
            </div>
        );
    }
    const videoRefsDesktop = useRef([]);
    const videoRefsMobile = useRef([]);
    const additionalVideoRefsDesktop = useRef([]);
    const additionalVideoRefsMobile = useRef([]);
    const videos = [1];
    const additionalVideos = [1, 1];
    // referencias para cada vídeo
    videoRefsDesktop.current = videos.map((_, i) => videoRefsDesktop.current[i] ?? createRef());
    videoRefsMobile.current = videos.map((_, i) => videoRefsMobile.current[i] ?? createRef());
    //  referencias para cada vídeo adicional
    additionalVideoRefsDesktop.current = additionalVideos.map((_, i) => additionalVideoRefsDesktop.current[i] ?? createRef());
    additionalVideoRefsMobile.current = additionalVideos.map((_, i) => additionalVideoRefsMobile.current[i] ?? createRef());
    const handleSlide = () => {
        const allVideoRefs = videoRefsDesktop.current.concat(videoRefsMobile.current)
            .concat(additionalVideoRefsDesktop.current)
            .concat(additionalVideoRefsMobile.current);

        allVideoRefs.forEach(videoRef => {
            if (videoRef.current && !videoRef.current.paused) {
                videoRef.current.pause();
            }
        });
    }

    return (
        <>
            <section className="marca-card">
                <link rel="preload" as="image" key="hyundaicare" href={HyundaiCareDesktop} />
                {/*<link rel="preload" as="video" key="sweden" href={sweden} />*/}
                <Carousel className="carousel-customize" pause={false} fade onSlide={handleSlide}>  
                    <Carousel.Item interval={6000}>
                        <Card className="carusel-inner-cotizaahora">
                            <LazyLoadImage
                                src={BannerMundial2026}
                                className="slider-img-desktop w-100 "
                                alt="Hyundai Tucson"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <LazyLoadImage
                                src={BannerMovilMundial2026}
                                className="slider-img-mobile w-100"
                                alt="Hyundai Tucson"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            {/*
                            <Card.ImgOverlay className="button-accent text-right cont-right">
                                <div>
                                    <Card.Text className="btn-informacion-light">
                                        <Link to="/cotizador/nuevo-tucson">
                                            <Button className="custom-button btn-cotizalo" variant="primary">Cotiza tu Tucson</Button>
                                        </Link>
                                    </Card.Text>
                                </div>
                            </Card.ImgOverlay>
                            */}
                        </Card>
                    </Carousel.Item>
                    <Carousel.Item interval={6000}>
                        <Card className="carusel-inner-cotizaahora">
                            <LazyLoadImage
                                src={BannerTucson}
                                className="slider-img-desktop w-100 "
                                alt="Hyundai Tucson"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <LazyLoadImage
                                src={BannerMovilTucson}
                                className="slider-img-mobile w-100"
                                alt="Hyundai Tucson"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <Card.ImgOverlay className="button-accent text-right cont-right">
                                <div>
                                    <Card.Text className="btn-informacion-light">
                                        <Link to="/cotizador/nuevo-tucson">
                                            <Button className="custom-button btn-cotizalo" variant="primary">Cotiza tu Tucson</Button>
                                        </Link>
                                    </Card.Text>
                                </div>
                            </Card.ImgOverlay>
                        </Card>
                    </Carousel.Item>
                    <Carousel.Item interval={6000}>
                        <Card className="carusel-inner-cotizaahora">
                            <LazyLoadImage
                                src={BannerSantaFe}
                                className="slider-img-desktop w-100 "
                                alt="Hyundai Santa Fe"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <LazyLoadImage
                                src={BannerMovilSantaFe}
                                className="slider-img-mobile w-100"
                                alt="Hyundai Santa Fe"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <Card.ImgOverlay className="button-accent text-right cont-right">
                                <div>
                                    <Card.Text className="btn-informacion-light">
                                        <Link to="/cotizador/nuevosantafe">
                                            <Button className="custom-button btn-cotizalo" variant="primary">Cotiza tu Santa Fe</Button>
                                        </Link>
                                    </Card.Text>
                                </div>
                            </Card.ImgOverlay>
                        </Card>
                    </Carousel.Item>
                    <Carousel.Item interval={6000}>
                        <Card className="carusel-inner-cotizaahora">
                            <LazyLoadImage
                                src={BannerCreta}
                                className="slider-img-desktop w-100 "
                                alt="Hyundai"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <LazyLoadImage
                                src={BannerMovilCreta}
                                className="slider-img-mobile w-100"
                                alt="Hyundai"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <Card.ImgOverlay className="button-accent text-right cont-right">
                                <div>
                                    <Card.Text className="btn-informacion-light">
                                        <Link to="/cotizador/nuevo-creta">
                                            <Button className="custom-button btn-cotizalo" variant="primary">Cotiza tu Creta</Button>
                                        </Link>
                                    </Card.Text>
                                </div>
                            </Card.ImgOverlay>
                        </Card>
                    </Carousel.Item>
                    <Carousel.Item interval={6000} >
                        <Card className="carusel-inner-cotizaahora">
                            <Image src={HyundaiCareDesktop} className="slider-img-desktop" alt="Hyundai Care" effect="blur" style={{ opacity: 1 }} fluid />
                            <Image src={HyundaiCareMovil} className="slider-img-mobile" alt="Hyundai Care" effect="blur" style={{ opacity: 1 }} fluid />
                        </Card>
                    </Carousel.Item>
                    <Carousel.Item interval={6000}>
                        <Card className="carusel-inner-cotizaahora">
                            <LazyLoadImage
                                src={BannerAccent}
                                className="slider-img-desktop w-100 "
                                alt="Hyundai Accent"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <LazyLoadImage
                                src={BannerMovilAccent}
                                className="slider-img-mobile w-100"
                                alt="Hyundai Accent Movil"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <Card.ImgOverlay className="button-accent text-right cont-right">
                                <div>
                                    <Card.Text className="btn-informacion-light">
                                        <Link to="/cotizador/nuevo-accent">
                                            <Button className="custom-button btn-cotizalo" variant="primary">Cotiza tu Accent</Button>
                                        </Link>
                                    </Card.Text>
                                </div>
                            </Card.ImgOverlay>
                        </Card>
                    </Carousel.Item>
                    <Carousel.Item interval={10000}>
                        <Card className="carusel-inner-cotizaahora">
                            <LazyLoadImage
                                src={BannerPrepagados}
                                className="slider-img-desktop w-100 "
                                alt="Hyundai"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <LazyLoadImage
                                src={BannerPrepagadosMovil}
                                className="slider-img-mobile w-100"
                                alt="Hyundai"
                                style={{ opacity: 1 }}
                                effect="blur"
                            />
                            <Card.ImgOverlay id="boton-prepagados" className="button-accent text-right cont-right">
                                <div>
                                    <Card.Text className="btn-informacion-light">
                                        <Link to="/prepagados">
                                            <Button className="custom-button btn-cotizalo">COTIZALO AHORA</Button>
                                        </Link>
                                    </Card.Text>
                                </div>
                            </Card.ImgOverlay>
                        </Card>
                    </Carousel.Item>
                </Carousel>
            </section>
            <Container className="div-lanzamientos lanzamiento-img-desktop">
                <Row className="mt-md-3">
                    <Col md={12}>
                        <div className='align-content-center text-center'>
                            <h1 className="model-title-light mt-5"><span
                                className="model-title-bold">Nuevos lanzamientos</span>
                            </h1>
                        </div>
                        <section>
                            <Slider {...settings}>
                                <div>
                                    <a href="/cotizador/nuevosantafe">
                                        <LazyLoadImage
                                            key="santafe"
                                            src={SantaFe}
                                            alt="Santa Fe"
                                            effect="blur"
                                            fluid="true"
                                            className="lanzamiento-image"
                                        />
                                        <p>Santa Fe</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="/cotizador/palisade">
                                        <span key="palisade">
                                            <LazyLoadImage
                                                key="palisade"
                                                src={Palisade}
                                                alt="Palisade Lanzamiento"
                                                effect="blur"
                                                fluid="true"
                                                className="lanzamiento-image"
                                            />
                                        </span>
                                        <p>PALISADE</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="/cotizador/nuevo-creta">
                                        <span key="creta">
                                            <LazyLoadImage
                                                key="creta"
                                                src={Creta}
                                                alt="Creta"
                                                effect="blur"
                                                fluid="true"
                                                className="lanzamiento-image"
                                            />
                                        </span>
                                        <p>CRETA</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="/cotizador/nuevosantafe">
                                        <LazyLoadImage
                                            key="santafe"
                                            src={SantaFe}
                                            alt="Santa Fe"
                                            effect="blur"
                                            fluid="true"
                                            className="lanzamiento-image"
                                        />
                                        <p>Santa Fe</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="/cotizador/palisade">
                                        <span key="palisade">
                                            <LazyLoadImage
                                                key="palisade"
                                                src={Palisade}
                                                alt="Palisade Lanzamiento"
                                                effect="blur"
                                                fluid="true"
                                                className="lanzamiento-image"
                                            />
                                        </span>
                                        <p>PALISADE</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="/cotizador/nuevo-creta">
                                        <span key="creta">
                                            <LazyLoadImage
                                                key="creta"
                                                src={Creta}
                                                alt="Creta"
                                                effect="blur"
                                                fluid="true"
                                                className="lanzamiento-image"
                                            />
                                        </span>
                                        <p>CRETA</p>
                                    </a>
                                </div>
                            </Slider>
                        </section>
                    </Col>
                </Row>
            </Container>
            <Container className="div-lanzamientos lanzamiento-img-mobile">
                <Row className="mt-md-3">
                    <Col md={12}>
                        <div className='align-content-center text-center'>
                            <h1 className="model-title-light mt-5"><span
                                className="model-title-bold">Nuevos lanzamientos</span>
                            </h1>
                        </div>
                        <section>
                            <Slider {...settingsMobile}>
                                <div>
                                    <a href="/cotizador/nuevosantafe">
                                        <LazyLoadImage
                                            key="santafe"
                                            src={SantaFe}
                                            alt="Santa Fe"
                                            effect="blur"
                                            fluid="true"
                                            className="lanzamiento-image"
                                        />
                                        <p>Santa Fe</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="/cotizador/palisade">
                                        <span key="palisade">
                                            <LazyLoadImage
                                                key="palisade"
                                                src={Palisade}
                                                alt="Palisade Lanzamiento"
                                                effect="blur"
                                                fluid="true"
                                                className="lanzamiento-image"
                                            />
                                        </span>
                                        <p>PALISADE</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="/cotizador/nuevo-creta">
                                        <span key="creta">
                                            <LazyLoadImage
                                                key="creta"
                                                src={Creta}
                                                alt="Creta"
                                                effect="blur"
                                                fluid="true"
                                                className="lanzamiento-image"
                                            />
                                        </span>
                                        <p>CRETA</p>
                                    </a>
                                </div>
                            </Slider>
                        </section>
                    </Col>
                </Row>
            </Container>
            <Container className="py-4 py-md-5">
                <Row>
                    <Col md={12}>
                        <div className='align-content-center text-center'>
                            <h1 className="model-title-light">
                                <span className="model-title-bold">Hyundai&nbsp;</span>
                                <span className="model-title-light">avanza para alcanzar la neutralidad</span>
                                <span className="text-inline">
                                    {" "}de carbono en 2045
                                </span>
                            </h1>
                        </div>
                        <div className="youtube-container">
                            <YouTubePlayer
                                dataSrc="https://www.youtube.com/embed/xOP7gYT2GQI?rel=0"
                                title="Hyundai avanza para alcanzar la neutralidad de carbono en 2045"
                                thumbnail={fondoVideo}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <section className="bg-blue mt-3">
                <Container style={{ color: '#ffffff' }} className="text-center">
                    <h1 className="model-title-light pt-5">Últimas noticias de <span
                        className="model-title-bold">Hyundai</span></h1>
                </Container>
                <CarouselNoticias />
            </section>
            <section>
                <Container>
                    <Row>
                        <Col md={4} className="mt-4 mt-md-5 mb-md-5">
                            <Link to="/nuestra-vision">
                                <picture>
                                    <source
                                        srcSet={VisionSmall}
                                        sizes="(max-width: 480px) 100vw"
                                        width={100}
                                        height={100}
                                    />
                                    <source
                                        srcSet={VisionMedium}
                                        sizes="(max-width: 768px) 50vw"
                                        width={100}
                                        height={100}
                                    />
                                    <source
                                        srcSet={VisionLarge}
                                        sizes="33vw"
                                        width={100}
                                        height={100}
                                    />
                                    <img
                                        src={VisionLarge}
                                        alt="Marca visión"
                                        className="w-100 responsive-image"
                                        loading="lazy"
                                    />
                                </picture>
                            </Link>
                            <h2 className="marca-tarjeta-titulo mt-3">VISION Y PROPÓSITO</h2>
                            <Link to="/nuestra-vision">
                                <h3 className="marca-tarjeta-subtitulo">Descubre nuestra visión.</h3>
                            </Link>
                        </Col>
                        <Col md={4} className="mt-4 mt-md-5 mb-md-5">
                            <Link to="/construyendo-suenos">
                                <picture>
                                    <source
                                        srcSet={SueniosSmall}
                                        sizes="(max-width: 480px) 100vw"
                                        width={100}
                                        height={100}
                                    />
                                    <source
                                        srcSet={SueniosMedium}
                                        sizes="(max-width: 768px) 50vw"
                                        width={100}
                                        height={100}
                                    />
                                    <source
                                        srcSet={SueniosLarge}
                                        sizes="33vw"
                                        width={100}
                                        height={100}
                                    />
                                    <img
                                        src={SueniosLarge}
                                        alt="Marca visión"
                                        className="w-100 responsive-image"
                                        loading="lazy"
                                    />
                                </picture>
                            </Link>
                            <h2 className="marca-tarjeta-titulo mt-3">ASPIRACIONES CUMPLIDAS</h2>
                            <Link to="/construyendo-suenos">
                                <h3 className="marca-tarjeta-subtitulo">Construyendo sueños.</h3>
                            </Link>
                        </Col>
                        <Col md={4} className="mt-4 mt-md-5 mb-md-5">
                            <Link to="/innovacion">
                                <picture>
                                    <source
                                        srcSet={InnovacionSmall}
                                        sizes="(max-width: 480px) 100vw"
                                        width={100}
                                        height={100}
                                    />
                                    <source
                                        srcSet={InnovacionMedium}
                                        sizes="(max-width: 768px) 50vw"
                                        width={100}
                                        height={100}
                                    />
                                    <source
                                        srcSet={InnovacionLarge}
                                        sizes="33vw"
                                        width={100}
                                        height={100}
                                    />
                                    <img
                                        src={InnovacionLarge}
                                        alt="Marca visión"
                                        className="w-100 responsive-image"
                                        loading="lazy"
                                    />
                                </picture>
                            </Link>
                            <h2 className="marca-tarjeta-titulo mt-3">INNOVACIÓN Y TECNOLOGIA</h2>
                            <Link to="/innovacion">
                                <h3 className="marca-tarjeta-subtitulo">Innovación.</h3>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                    </Row>
                </Container>
            </section>
        </>
    );
};
export default Novedades;